__turbopack_context__.v({
  "actions": "Scripts-module__QzhUpa__actions",
  "addBtn": "Scripts-module__QzhUpa__addBtn",
  "blocks": "Scripts-module__QzhUpa__blocks",
  "callModeToggle": "Scripts-module__QzhUpa__callModeToggle",
  "callType": "Scripts-module__QzhUpa__callType",
  "callTypeSelect": "Scripts-module__QzhUpa__callTypeSelect",
  "card": "Scripts-module__QzhUpa__card",
  "cardTop": "Scripts-module__QzhUpa__cardTop",
  "loaderContainer": "Scripts-module__QzhUpa__loaderContainer",
  "menuAction": "Scripts-module__QzhUpa__menuAction",
  "updateBanner": "Scripts-module__QzhUpa__updateBanner",
  "updateText": "Scripts-module__QzhUpa__updateText",
});
